<template>
   <div class="bar">
      <div v-for="tab in tabs" class="button-container"> 
         <tab-button 
            :active="tab.id === activeItemId"
            :label="tab.label"
            :id="tab.id"
            :type="type"
            @clicked="clicked"
         />
      </div>
   </div>
</template>

<script>
export default {
   name: 'TabBar',
   props: {
      tabs: {
         type: Array,
         required: true
      },
      contextPath: {
         type: String,
         required: true
      },
      activeItemId: {
         type: String,
         required: false
      },
      type: {
         type: String,
         required: false
      }
   },
   data: function () {
      return {}
   },
   computed:  {},
   methods: {
      clicked: function (itemId) {
         this.$emit('clicked', { 
            itemId: itemId, 
            contextPath: this.contextPath.toLowerCase()
         });
      }
   }
}
</script>

<style scoped>
.bar {
   text-align: justify;
}

.button-container {
   display: inline-block;
   padding: 0rem 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form/TabBar.vue